import * as React from 'react';

import { Col, ConsoleDialog, Row } from '@rematter/ui-web';

import { useAuditLogLocation } from '../../_state/auditLogModule.state';
import { useTranslations } from '../../i18n/useTranslations';

import { AuditLogMenu } from './AuditLogMenu';

type AuditLogRootLayoutProps = {
  children: React.ReactNode;
};

export const AuditLogRootLayout = ({ children }: AuditLogRootLayoutProps) => {
  const t = useTranslations();
  const [, setLocation] = useAuditLogLocation();

  return (
    <ConsoleDialog
      className="@AuditLogRootLayout"
      contentClassName="p-0 flex-1"
      content={
        <Row className={'h-full'} yStretch>
          <Col
            className={'shrink-0 overflow-y-auto border-r border-neutral/10'}
          >
            <AuditLogMenu />
          </Col>
          <Col className={'h-full w-full overflow-y-auto'}>{children}</Col>
        </Row>
      }
      title={t.routes.title}
      size="fill"
      isOpen
      onOpenChange={() => setLocation(undefined)}
      closeWithEscapeKey={false}
    />
  );
};
